module.exports = "https://cdn-challenge.mathletics.com/app/107/assets/images/a42db4a90ab6149827c1a853f82925d7.svg";